var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { collectDebugInfo } from './debugDataCollector';
import { installFetchInterceptor } from './apiHistoryTracker';
import { isTestEnvironment } from '../utils/environment';
import styles from './DebugInfoButton.module.css';
// Debug tooling is available on the same test/development hosts as other
// test-only UI (shared allow-list in ../utils/environment).
var isDebugEnabled = function () { return isTestEnvironment(); };
var DebugInfoButton = function (_a) {
    var stripes = _a.stripes;
    var formatMessage = useIntl().formatMessage;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState(''), debugText = _c[0], setDebugText = _c[1];
    var _d = useState(false), copied = _d[0], setCopied = _d[1];
    useEffect(function () {
        if (isDebugEnabled()) {
            installFetchInterceptor();
        }
    }, []);
    var handleOpen = useCallback(function () {
        var text = collectDebugInfo(stripes);
        setDebugText(text);
        setCopied(false);
        setIsOpen(true);
    }, [stripes]);
    var handleClose = useCallback(function () {
        setIsOpen(false);
    }, []);
    var handleCopy = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, textarea;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.clipboard.writeText(debugText)];
                case 1:
                    _b.sent();
                    setCopied(true);
                    setTimeout(function () { return setCopied(false); }, 2000);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    textarea = document.createElement('textarea');
                    textarea.value = debugText;
                    document.body.appendChild(textarea);
                    textarea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textarea);
                    setCopied(true);
                    setTimeout(function () { return setCopied(false); }, 2000);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [debugText]);
    var handleSave = useCallback(function () {
        var blob = new Blob([debugText], { type: 'text/plain' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        var timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
        a.download = "debug-info-".concat(timestamp, ".txt");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }, [debugText]);
    var handleOverlayClick = useCallback(function (e) {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    }, [handleClose]);
    if (!isDebugEnabled())
        return null;
    var t = function (key) { return formatMessage({ id: "stripes-core.".concat(key) }); };
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: styles.navButton, onClick: handleOpen, title: t('debugInfo.title'), "aria-label": t('debugInfo.button.ariaLabel') },
            React.createElement("span", { className: styles.navButtonInner }, "\uD83D\uDC1B")),
        isOpen && (React.createElement("div", { className: styles.overlay, onClick: handleOverlayClick, role: "presentation" },
            React.createElement("div", { className: styles.modal, role: "dialog", "aria-label": t('debugInfo.title') },
                React.createElement("div", { className: styles.header },
                    React.createElement("h2", null, t('debugInfo.title')),
                    React.createElement("button", { type: "button", className: styles.closeButton, onClick: handleClose, "aria-label": t('debugInfo.button.close') }, "\u00D7")),
                React.createElement("div", { className: styles.content },
                    React.createElement("pre", { className: styles.debugText }, debugText)),
                React.createElement("div", { className: styles.actions },
                    React.createElement("button", { type: "button", className: styles.primaryButton, onClick: handleCopy }, t('debugInfo.button.copyToClipboard')),
                    React.createElement("button", { type: "button", className: styles.actionButton, onClick: handleSave }, t('debugInfo.button.saveAsFile')),
                    copied && React.createElement("span", { className: styles.copiedFeedback }, t('debugInfo.copied'))))))));
};
export { DebugInfoButton };
